import { IDefineCommand, IQuery } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import { ConversationThread } from '../builders/conversation_thread_builder';

angular
  .module('capability-ng-conversations')
  .factory(
    'updateConversationThreadStatusCommand',
    (accountModel: AccountModel, log: any, $http: ng.IHttpService, defineCommand: IDefineCommand) => {
      return defineCommand(
        'updateConversationThreadStatusCommand',
        (deferred: ng.IDeferred<IQuery[]>, thread: ConversationThread) => {
          const originalStatus = thread.status;
          const status = thread.status === 'FLAGGED' ? 'READ' : 'FLAGGED';

          $http
            .put(`notification/students/${accountModel.student_nk}/messages/${thread.id}`, {
              status
            })
            .then((): void => {
              thread.status = status;
              deferred.resolve();
            })
            .catch((error): void => {
              thread.status = originalStatus;
              log.user.error('Something went wrong! Please try again.');
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/commands/update_conversation_thread_status_command.ts